<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="servicio" titulo="Servicios / Servicios financieros" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<div class="contenedor columns " style="height:100%; ">

    <div class="column is-2 is-hidden-mobile menu-izquierda">

        <!-- Menu izquierda del modulo enviroment" -->
        <app-sistema-menu-aside></app-sistema-menu-aside>
    </div>
    <div class="column" style="padding:0px;">
        <div style="background: #FFF; border-radius: 1em; ">

            <!-- inicio formulario -->
            <form name="form" novalidate [formGroup]="dato" (ngSubmit)="ctrl.enviar()">
                <section class="hero is-primary">
                    <div class="hero-body">

                        <!-- Opciones  -->
                        <app-formulario-opciones [ctrl]="ctrl" [id]="ctrl.dato.id"></app-formulario-opciones>
                    </div>
                </section>
                <div class="is-fullwidth has-text-centered" *ngIf="!ctrl.datosCargados">
                    <br>
                    <span class="tag is-primary is-large ">
                        <span class="icon">
                            <i class="icon-worldwide fa-spin"></i>
                        </span> &nbsp;
                        <span>Cargando...</span>
                    </span>
                </div>

                <section class="section" style="overflow: auto;padding: 1rem !important;height: 85.8vh;">
                    <a id="catalogos" (click)="ctrl.cargarCatalogo('categorias', 'categoria'); ctrl.cargarCatalogo('catalogos_impuestos', CFDI_PATH+'/api/v1/catalogo-impuesto'); ctrl.cargarCatalogo('catalogos_factores',
                    CFDI_PATH+'/api/v1/catalogo-factor')"></a>
                    <a id="filtra-categoria" (click)="filtraCategoria(ctrl.categorias);"></a>
                    <div class="tabs is-boxed">
                        <ul>
                            <li [ngClass]="{ 'is-active' : tab == 1}">
                                <a (click)="tab=1">
                                    <span class="icon ">
                                        <i class="fa fa-home"></i>
                                    </span>
                                    <span>General</span>
                                </a>
                            </li>

                            <li [ngClass]="{ 'is-active' : tab == 2}">
                                <a (click)="tab=2">
                                    <span class="icon ">
                                        <i class="fa fa-gavel"></i>
                                    </span>
                                    <span>Impuestos</span>
                                </a>
                            </li>

                        </ul>
                    </div>

                    <div [ngClass]="{ 'is-hidden': tab != 1}">
                        <div class="field is-grouped" style=" width: 100%; ">
                            <div class="control has-icons-left is-expanded">
                                <label class="label">Seleccione la clave de producto o servicio correspondiente del cátalogo del SAT:</label>
                                <input autofocus autocomplete="off" ngui-auto-complete [source]="observableSource.bind(this)" [list-formatter]="autocompleListFormatter" [close-on-focusout]="false"
                                    id='buscarArticulo' value-property-name="clave" display-property-name="nombre" path-to-data=""
                                    loading-text="Cargando..." no-match-found-text="No hay resultados." (valueChanged)="seleccionarValorSelect2($event)"
                                    min-chars="3" class="input is-success is-medium" type="text" placeholder="Escribe la calve o el nombre del producto/servicio">
                                <span class="icon is-medium is-left">
                                    <i class="icon-search3"></i>
                                </span>
                            </div>
                        </div>

                        <div class="field">
                            <label class="label">Clave de producto o servicio SAT:</label>
                            <p class="control has-icons-left has-icons-right">
                                <input class="input" autofocus type="text" [ngClass]="{'is-danger': ctrl.dato.get('clave_prod_serv').hasError('required') }"
                                    placeholder="Clave de producto o servicio" formControlName="clave_prod_serv" readonly>
                                <span class="icon is-small is-right" *ngIf="ctrl.dato.get('clave_prod_serv').hasError('required') ">
                                    <i class="fa fa-warning"></i>
                                </span>
                                <span class="help is-danger" *ngIf="ctrl.dato.get('clave_prod_serv').hasError('required') ">Este campo es requerido.</span>
                            </p>
                        </div>

                        <div class="field">
                            <label class="label">SKU (No. de identificación):</label>
                            <p class="control">
                                <input class="input" type="text" placeholder="SKU" formControlName="sku" readonly>
                            </p>
                        </div>

                        <div class="field" *ngIf="activar_super">
                            <label class="label">Categoría:</label>
                            <div class="select">
                                <select class="select" name="categorias_id" #categoria formControlName="categorias_id" (change)="cambio_categoria(ctrl.categorias, categoria.value)">
                                    <option *ngFor="let val of ctrl.categorias" value="{{val.id}}">({{val.clave}}) {{ val.nombre }}</option>
                                </select>
                            </div>
                        </div>

                        <div class="field">
                            <label class="label">Nombre:</label>
                            <p class="control has-icons-left has-icons-right">
                                <input class="input" type="text" [ngClass]="{'is-danger': ctrl.dato.get('nombre').hasError('required') }" placeholder="Nombre"
                                    formControlName="nombre">
                                <span class="icon is-small is-right" *ngIf="ctrl.dato.get('nombre').hasError('required') ">
                                    <i class="fa fa-warning"></i>
                                </span>
                                <span class="help is-danger" *ngIf="ctrl.dato.get('nombre').hasError('required') ">Este campo es requerido.</span>
                            </p>
                        </div>
                        <div class="field" formArrayName="articulos_precios" >
                            <div *ngFor="let val of ctrl.dato.controls.articulos_precios.controls; let i=index" [formGroupName]="0">
                                <div *ngIf="i <= 0">
                                    <label class="label">Importe:</label>
                                    <p class="control has-icons-left has-icons-right">
                                        <input class="input" type="number" placeholder="Importe" formControlName="precio">
                                    </p>
                                </div>

                                <!-- <div *ngIf="!i">
                                    <label class="label">Importe:</label>
                                    <p class="control has-icons-left has-icons-right">
                                        <input class="input" type="number" placeholder="Importe" formControlName="precio">
                                    </p>
                                </div> -->
                            </div>

                        </div>
                        <div class="column is-4" *ngIf="activar_super">
                            <br>
                            <div class="field">
                                <div class="b-checkbox is-info">
                                    <input id="es_super" class="styled" type="checkbox" formControlName="su">
                                    <label for="es_super">
                                        Es super?
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- IMPUESTOS -->
                    <div [ngClass]="{ 'is-hidden': tab != 2}">
                        <div class="notification is-warning">

                           Nota:
                            <strong>Estos impuestos son adicionales</strong>, a los que ya se configuraron de manera global
                        </div>
                        <div formGroupName="articulos_impuestos">
                          <div formGroupName="impuestos">
                            <nav class="panel" formArrayName="traslados">
                                <p class="panel-heading">
                                    Impuestos trasladados
                                </p>
                                <div class="panel-block" *ngFor="let impuesto of ctrl.dato.controls.articulos_impuestos.controls.impuestos.controls.traslados.controls; let i = index;">
                                    <table class="table is-striped  is-fullwidth" [formGroupName]="i">
                                        <thead>
                                            <tr>
                                                <th>{{i+1}}</th>
                                                <th>Impuesto:
                                                    <div class="select">
                                                        <select class="select" formControlName="clave" (change)="seleccionarValorSelect(impuesto.get('clave').value, impuesto, ctrl.catalogos_impuestos);">
                                                            <option *ngFor="let val of ctrl.catalogos_impuestos" value="{{val.clave}}">({{val.clave}}) {{ val.nombre }}</option>
                                                        </select>
                                                    </div>
                                                </th>
                                                <th>Factor:
                                                    <div class="select">
                                                        <select class="select" formControlName="factor">
                                                            <option *ngFor="let val of ctrl.catalogos_factores" value="{{val.nombre}}">{{ val.nombre }}</option>
                                                        </select>
                                                    </div>
                                                </th>
                                                <th>Cuota:
                                                    <input class="input" type="number" formControlName="cuota" id="cuota_tras{{i}}">
                                                </th>
                                                <td align="right">
                                                    <button type="button" class="button is-danger" (click)="ctrl.quitar_form_array(ctrl.dato.controls.articulos_impuestos.controls.impuestos.controls.traslados, i)">
                                                        <i class="icon-trash"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </thead>
                                    </table>

                                </div>
                                <div class="panel-block">
                                    <button type="button" class="button is-default" (click)="ctrl.agregar_form_array(ctrl.dato.controls.articulos_impuestos.controls.impuestos.controls.traslados, form_articulos_impuestos)">
                                        <i class="icon-add2"></i>
                                    </button>
                                </div>
                            </nav>

                            <nav class="panel" formArrayName="retenciones">
                                <p class="panel-heading">
                                    Impuestos retenciones
                                </p>
                                <div class="panel-block" *ngFor="let impuesto of ctrl.dato.controls.articulos_impuestos.controls.impuestos.controls.retenciones.controls; let i = index;">
                                    <table class="table is-striped  is-fullwidth" [formGroupName]="i">
                                        <thead>
                                            <tr>
                                                <th>{{i+1}}</th>
                                                <th>Impuesto:
                                                    <div class="select">
                                                        <select class="select" formControlName="clave" (change)="seleccionarValorSelect(impuesto.get('clave').value, impuesto, ctrl.catalogos_impuestos);">
                                                            <option *ngFor="let val of ctrl.catalogos_impuestos" value="{{val.clave}}">({{val.clave}}) {{ val.nombre }}</option>
                                                        </select>
                                                    </div>
                                                </th>
                                                <th>Factor:
                                                    <div class="select">
                                                        <select class="select" formControlName="factor">
                                                            <option *ngFor="let val of ctrl.catalogos_factores" value="{{val.nombre}}">{{ val.nombre }}</option>
                                                        </select>
                                                    </div>
                                                </th>
                                                <th>Cuota:
                                                    <input class="input" type="number" formControlName="cuota" id="cuota_ret{{i}}">
                                                </th>
                                                <td align="right">
                                                    <button type="button" class="button is-danger" (click)="ctrl.quitar_form_array(ctrl.dato.controls.articulos_impuestos.controls.impuestos.controls.retenciones, i)">
                                                        <i class="icon-trash"></i>
                                                    </button>
                                                </td>
                                            </tr>
                                        </thead>
                                    </table>

                                </div>
                                <div class="panel-block">
                                    <button type="button" class="button is-default" (click)="ctrl.agregar_form_array(ctrl.dato.controls.articulos_impuestos.controls.impuestos.controls.retenciones, form_articulos_impuestos)">
                                        <i class="icon-add2"></i>
                                    </button>
                                </div>
                            </nav>
                          </div>
                        </div>

                    </div>


                </section>

            </form>
        </div>
    </div>
</div>
